/* src/utils/constants.js */

export const APP_NAME = 'EveryThingRental';
export const TAG_LINE = 'Liablities change into Assests';

export const CATEGORIES = [
  'Vehicles', 'Tools', 'Electronics', 'Furniture', 'Party Supplies',
  'Sports Equipment', 'Clothing & Accessories', 'Camera & Photography',
  'Musical Instruments', 'Fashion', 'Appliances', 'Kitchen Appliances',
  'Smart Gadgets', 'Home/Apartment', 'Toys, Baby & Books', 'Sports Hub',
  'Auto Accessories', 'Bikes & Scooters', 'Home Services', 'Others'
];